import { ConvertibleEntity } from 'types/ConvertibleEntity'
import i18n from 'i18next'
import { getConvertibleLoanAmount } from '@finance-lab/utils/shared'

export const getConvertibleNoncashConsiderationLabel = (
    convertible: Pick<ConvertibleEntity, 'noncashConsideration' | 'linkedIssues'>,
): string | null => {
    if (convertible.noncashConsideration) {
        return convertible.noncashConsideration
    }

    return null
}

export const getConvertibleStatusLabel = (convertible: ConvertibleEntity) => {
    if (convertible.completed) {
        return i18n.t('pages.convertibles.status.repaid')
    }

    const loanAmount = getConvertibleLoanAmount(convertible)
    if (convertible.creditLine !== null && (loanAmount === null || loanAmount === 0)) {
        return i18n.t('pages.convertibles.status.unusedCreditLine')
    }

    return i18n.t('pages.convertibles.status.outstandingLoan')
}
